
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/statistics/common",
      function () {
        return require("private-next-pages/[locale]/statistics/common/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/statistics/common"])
      });
    }
  